@if (startTimestamp || endTimestamp) {
  <span class="me-2 fa fa-clock "></span>
  @if (startTimestamp) {
    @if (startTimestamp.date) {
      <span class="me-1 " [ngClass]="startClass"
      >{{ startTimestamp.date }}</span>
    }<span>{{ startTimestamp.time }}</span>
  } @else {
    <span class="me-1">?</span>
  }
  <span [ngClass]="endClass">
      <span> – </span>
    @if (endTimestamp) {
      @if (endTimestamp.date) {
        <span class="me-1 ">{{ endTimestamp.date }}</span>
      }<span>{{ endTimestamp.time }}</span>
    } @else {
      <span class="me-1">?</span>
    }
      </span>
}

